// extracted by mini-css-extract-plugin
export default {"AboutContainer":"About_AboutContainer__rfDT7","TitleAbout":"About_TitleAbout__Vaur1","ThumbVideos":"About_ThumbVideos__ZJND1","AboutContent":"About_AboutContent__+LBJO"};